import { BaseModel } from "@shared/models/entity/base/base.model";
import { Post } from "../post/post.model";

interface IChannel {
    name: string;

    description: string;

    isModerated: boolean;

    membersCanPost: boolean;

    notifyOnNewPosts: boolean;

    metadata: ChannelMetadata;

    // -----------------------------------------------------------------------------------------------------
    // @ 1 : N RELATIONS
    // -----------------------------------------------------------------------------------------------------

    posts: Post[];

    // -----------------------------------------------------------------------------------------------------
    // @ M : N RELATIONS
    // -----------------------------------------------------------------------------------------------------

    userConfigurations: unknown[];
}

export class Channel extends BaseModel implements IChannel {

    name: string;

    description: string;

    isModerated: boolean = false;

    membersCanPost: boolean = true;

    notifyOnNewPosts: boolean = true;

    metadata: ChannelMetadata;

    // -----------------------------------------------------------------------------------------------------
    // @ 1 : N RELATIONS
    // -----------------------------------------------------------------------------------------------------

    posts: Post[];

    // -----------------------------------------------------------------------------------------------------
    // @ M : N RELATIONS
    // -----------------------------------------------------------------------------------------------------

    userConfigurations: unknown[] = [];

    // --------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // --------------------------------------------------------------------------------------

    constructor(init?: Partial<Channel>) {
        super(init);

        if (init) { Object.assign(this, init); }
    }
}

// --------------------------------------------------------------------------------------
// @ METADATA
// --------------------------------------------------------------------------------------

interface IChannelMetadata { }

export class ChannelMetadata implements IChannelMetadata { }